import React, { useState } from "react";

const MediaUpload = () => {
  const [images, setImages] = useState([]); // State to store uploaded images
  const [videos, setVideos] = useState([]); // State to store uploaded videos
  const [previewImages, setPreviewImages] = useState([]); // Preview for images
  const [previewVideos, setPreviewVideos] = useState([]); // Preview for videos

  // Handle image upload
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setImages((prev) => [...prev, ...files]);
    const imagePreviews = images.map((file) => URL.createObjectURL(file));
    setPreviewImages((prev) => [...prev, ...imagePreviews]);
  };

  // Handle video upload
  const handleVideoUpload = (e) => {
    const files = Array.from(e.target.files);
    setVideos((prev) => [...prev, ...files]);
    const videoPreviews = videos.map((file) => URL.createObjectURL(file));
    setPreviewVideos((prev) => [...prev, ...videoPreviews]);
  };

  return (
    <div className="bg-white shadow-lg p-8 rounded-md w-full max-w-4xl">
      <h2 className="text-xl font-semibold mb-4">Upload Media for Packing and Preparing Food</h2>

      {/* Image Upload Section */}
      <div className="mb-6">
        <label className="block text-gray-700 font-medium mb-2">Upload Images</label>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageUpload}
          className="block w-full p-2 border border-gray-300 rounded-md"
        />
        <div className="mt-4 grid grid-cols-4 gap-4">
          {previewImages.map((image, index) => (
            <div key={index} className="border rounded-md overflow-hidden">
              <img src={image} alt="Preview" className="object-cover w-full h-40" />
            </div>
          ))}
        </div>
      </div>

      {/* Video Upload Section */}
      <div className="mb-6">
        <label className="block text-gray-700 font-medium mb-2">Upload Videos</label>
        <input
          type="file"
          accept="video/*"
          multiple
          onChange={handleVideoUpload}
          className="block w-full p-2 border border-gray-300 rounded-md"
        />
        <div className="mt-4 grid grid-cols-2 gap-4">
          {previewVideos.map((video, index) => (
            <div key={index} className="border rounded-md overflow-hidden">
              <video controls className="w-full h-40">
                <source src={video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </div>
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        className="bg-orange-500 text-white px-4 py-2 rounded-md"
      >
        Upload Media
      </button>
    </div>
  );
};

export default MediaUpload;